import React from "react";
import { executeQuery, REACT_APP_ADMIN_LINK } from "../../utils";
import { useQuery } from "@tanstack/react-query";
import IntegrationIcon from "../../shared/icons/IntegrationIcon";
import { Link } from "react-router-dom";

const IntegrationsButton = () => {
  const user = JSON.parse(localStorage.getItem("user") ?? "{}");
  const { data } = useQuery<{ flags: string[] }>({
    queryKey: ["featureFlags"],
    queryFn: () =>
      executeQuery({
        path: "/feature-flags/user",
        params: { userId: user.teachercode ?? "" },
      }),
    refetchOnWindowFocus: false,
  });

  if (!data) {
    return <></>;
  }

  return data.flags.includes("admin_integrations") ? (
    <div className="text-md group flex w-full items-center rounded-md py-2 pl-2 font-medium text-dm-gray-600 hover:cursor-pointer hover:underline">
      <Link to={`${REACT_APP_ADMIN_LINK}/integrations`}>
        <IntegrationIcon classes="mr-2" />
        Integrations
      </Link>
    </div>
  ) : (
    <></>
  );
};

export default IntegrationsButton;
